import api from "@/lib/api";

const PART = 4 * 1024 * 1024;

export const audioExt = (type = "", name = "") => {
  const n = name.split(".").pop().toLowerCase();
  if (name && n.length <= 4) return n;
  return type.includes("mp4") ? "m4a" : type.includes("ogg") ? "ogg" : type.includes("mpeg") ? "mp3" : "webm";
};

// Uploads one audio segment in 4 MB parts; retries each part on network errors.
export async function uploadSegment(mid, seg, blob, ext, onProgress) {
  const parts = Math.max(1, Math.ceil(blob.size / PART));
  for (let i = 0; i < parts; i++) {
    const fd = new FormData();
    fd.append("seg", seg); fd.append("part", i); fd.append("parts", parts); fd.append("ext", ext);
    fd.append("file", blob.slice(i * PART, (i + 1) * PART), `seg${seg}.${ext}`);
    for (let attempt = 0; ; attempt++) {
      try { await api.post(`/meetings/${mid}/segments`, fd); break; } catch (e) {
        if (attempt >= 5 || (e.response && e.response.status < 500)) throw e;
        await new Promise((r) => setTimeout(r, 3000 * (attempt + 1)));
      }
    }
    onProgress?.((i + 1) / parts);
  }
}

export async function finalizeMeeting(mid, durationSec) {
  const fd = new FormData();
  fd.append("durationSec", Math.round(durationSec || 0));
  await api.post(`/meetings/${mid}/finalize`, fd);
}
